import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-textline',
  templateUrl: './textline.component.html',
  styleUrls: ['./textline.component.scss']
})
export class TextlineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
